import React, { useState, useEffect } from 'react';
import OrderCrudService from '../../services/OrderCrudService';
import { Alert, Accordion, Button, Col, Form, Modal, Row, Spinner, Tab, Tabs } from 'react-bootstrap';

export default function ModalMultiOrders({ show, handleClose, dataItem, setRenderRows }) {

  const [validated, setValidated] = useState(false);
  const conditionView = (dataItem.typeView === 'View' || dataItem.typeView === 'Delete') ? true : false;
  const [viewSpinner, setViewSpinner] = useState(false);
  const [successSend, setSuccessend] = useState(null);
  const [countSend, setCountsend] = useState(null);
  const [currentOrders, setCurrentOrders] = useState([]);
  const [enableSaveChanges, setEnableSaveChanges] = useState(false);

  useEffect(() => {
    if (show && dataItem.codeItem.length > 0) {

      dataItem.codeItem.forEach(codeItem => {
        let codeItemSplit = codeItem.split('-');
        OrderCrudService.getOrderById(codeItemSplit[1], codeItemSplit[0]).then(async res => {

          let currentClient = res.data.data[0];
          setCurrentOrders(currentOrders => [...currentOrders, currentClient]);
        });
      });

    } else {

      setCurrentOrders([]);
      setSuccessend(null);
      setCountsend(null);
      setEnableSaveChanges(false);

    }
  }, [dataItem, show]);

  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time)
    )
  }

  const handleSubmit = async () => {
    setViewSpinner(true);
    setEnableSaveChanges(true);
    let successCount = 0;
    let errorCount = 0;

    for (const codeItem of dataItem.codeItem) {
      let codeItemSplit = codeItem.split('-');
      let updateOrder = { storeCode: codeItemSplit[0], code: codeItemSplit[1] };

      await sleep(2000);

      try {
        const res = await OrderCrudService.resendOrder(updateOrder);
        console.log('success');
        successCount++;
      } catch (err) {
        console.log(err);
        if (err.response.status !== 200) {
          errorCount++;
        }
      }

      console.log('updateOrder', updateOrder);
    }

    setViewSpinner(false);

    if (errorCount === 0) {
      setSuccessend('success');
      setCountsend(successCount + ' de ' + dataItem.codeItem.length);
    } else {
      setSuccessend('danger');
      setCountsend(errorCount + ' de ' + dataItem.codeItem.length);
    }

    await sleep(2000);
    handleClose();
    window.location.href = '/Orders';
  };

  let addSubmitButton = "";
  if (!conditionView) {
    addSubmitButton = (<><Button type="button" disabled={enableSaveChanges} onClick={() => handleSubmit()} > ReEnviar Ordenes </Button></>);
  }

  const setCloseButton = <><Button variant="secondary" disabled={enableSaveChanges} onClick={handleClose}> Close </Button> </>;

  return (
    <>
      <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title> {dataItem.typeView} {dataItem.nameView} </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Tabs
            defaultActiveKey="main"
            id="justify-tab-example"
            className="mb-3"
            justify
          >
            <Tab eventKey="main" title={"Data " + dataItem.nameView}>

              <Row className="mb-3">

                <Accordion>
                  {currentOrders.map((itemOrder) => {
                    return (
                      <Accordion.Item eventKey={itemOrder.code - itemOrder.storeCode} key={itemOrder.code - itemOrder.storeCode}>
                        <Accordion.Header>StoreCode : {itemOrder.storeCode} - Code : {itemOrder.code} </Accordion.Header>
                        <Accordion.Body>
                          <pre>
                            UserName : {itemOrder.customer.username}
                          </pre>
                          <pre>
                            PayMethod : {itemOrder.payMethod} Status : {itemOrder.status}
                          </pre>
                        </Accordion.Body>
                      </Accordion.Item>
                    )
                  })}
                </Accordion>
              </Row>
              {viewSpinner && (
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              )}
              <hr></hr>
            </Tab>
          </Tabs>

          {addSubmitButton}
          {'  '}  {'  '}
          {setCloseButton}
          {(successSend == 'danger') ?
            (<Alert key='danger' variant='danger'> {countSend} - No Enviadas!</Alert>)
            : (successSend == 'success') ?
              (<Alert key='success' variant='success'> {countSend} - Enviadas! </Alert>) : ""
          }
        </Modal.Body>
      </Modal>
    </>
  );
}